import eventMap, { Address } from '../component/event/event-mapper';
import Constructor from '../util/constructor';
import MetaValidator from '../util/meta-validator';

import { get, isController } from './controller';

const paramsValidator = MetaValidator.create().str('type', true).custom('target', false, (value) => {
  return typeof value === 'string' || Array.isArray(value);
}).validator();

export interface EventArgs {
  type: string;
  target?: string|string[];
}

function EventListener(definition: Constructor|EventArgs, name: string, descriptor: PropertyDescriptor, params: EventArgs): PropertyDescriptor {
  const validate = MetaValidator.validateDecorator(EventListener, paramsValidator, definition as Constructor, params);

  if (validate) {
    return validate;
  }

  setTimeout(() => {
    if (!isController(definition)) {
      MetaValidator.logError(definition.toString(), name, 'The class is not a valid @Controller.');
    }

    const { fragment, component } = get(definition);
    const { type, target = component } = params;

    const targets = Array.isArray(target) ? target : [target];

    const address = new Address(definition.constructor.name, name || '');

    targets.forEach(t => {
      const comp = eventMap.getComponent(fragment, t);
      comp && comp.insert(type, address);
    });
  });

  return descriptor;
}

function generator(type: string): Function {
  return function (definition: Constructor|EventArgs, name: string, descriptor: TypedPropertyDescriptor<object>): TypedPropertyDescriptor<object> {
    if (definition.constructor === Object) {
      return EventListener({ ...definition, type }, name, descriptor, { type });
    } else if (definition instanceof Object) {
      return EventListener(definition, '', {}, { type }); 
    }
    throw new Error(`Invalid arguments: ${definition}, ${name}, ${descriptor}`);
  };
}

export { EventListener as default, generator };
